import React from 'react'
import ImageUpload from '../../../components/ImageCropper/ImageUpload'

const LogoUpload = () => {
  return <ImageUpload />
}

export default LogoUpload
